import type { Type } from '@angular/core';
import type { BuildingSelectorPanel } from '../top-bar-building-selector/top-bar-building-selector';

export async function loadBuildingSelectorPanel(): Promise<
    Type<BuildingSelectorPanel>
> {
    const { BuildingSelectorPanel } =
        await import('../top-bar-building-selector');

    return BuildingSelectorPanel;
}
